module.exports = __webpack_public_path__ + "img/bld_logo_tsl.svg";